import React, { useContext } from 'react'

import { Box } from 'component-library/compositions/Box/Box'
import { GalleryBreach } from 'component-library/user-registration/breach/GalleryBreach'
import { Gallery } from 'component-library/content/Gallery/Gallery'
import { GalleryPublicationProps } from '../SharedPublication.routing'
import { ConfigurationContext } from 'common/context-providers/configuration-context'
import { useSectionMeta } from 'common/routing/use-section-meta'
import { getBaseUrl } from 'common/routing/url'
import { AdUnitWrapper } from 'component-library/advertising/AdUnit/AdUnitWrapper'

export const TheWestGallery: React.FC<GalleryPublicationProps> = ({
    gallery,
    galleryMeta,
    location,
    onEvent,
    adState,
}) => {
    const { publicUrl } = useContext(ConfigurationContext)
    const sectionMeta = useSectionMeta()
    const url =
        getBaseUrl(publicUrl, sectionMeta) + '/' + gallery.primaryTopic.id + '/' + gallery.slug

    return (
        <Box verticalSpacing="md">
            <GalleryBreach
                isPremium={gallery.isPremium}
                location={location}
                onEvent={onEvent}
                publicationId={gallery.id}
                images={gallery.images}
                slug={gallery.slug}
            >
                {({ images }, entitled) => (
                    <Gallery
                        entitled={entitled}
                        isPremium={gallery.isPremium}
                        title={gallery.heading}
                        images={images}
                        adFrequency={3}
                        publicationDate={gallery.publicationDate}
                        profile={gallery.profile}
                        byline={gallery.byline}
                        source={gallery.source}
                        ads={galleryMeta.galleryAds.map(ad => (
                            <AdUnitWrapper
                                hiddenUntilLoaded={ad.hiddenUntilLoaded}
                                noticePosition={ad.noticePosition}
                                padding={ad.padding}
                                adState={adState}
                                unitId={ad.slot.id}
                                onEvent={onEvent}
                            />
                        ))}
                        mainImage={gallery.heroImage}
                        shareUrl={url}
                        onEvent={onEvent}
                    />
                )}
            </GalleryBreach>
        </Box>
    )
}
